export default {
  LOCALHOST_TOKEN: ''
};
